import type { Database } from "../../../__definitions__/database-definitions";
import { SupabaseServiceView } from "../../../server/supabase/base-supabase-service";

export type OptedOut = Database["public"]["Views"]["opted_out"]["Row"];

export class SupabaseOptedOutService extends SupabaseServiceView<"opted_out"> {
  table = "opted_out" as const;
}
